// extracted by mini-css-extract-plugin
module.exports = {"body":"NewFileDialog_body__YxYwE","content":"NewFileDialog_content__Tyruc","types":"NewFileDialog_types__39him","error":"NewFileDialog_error__Cv30M"};